import { GetData } from "./Functions/SettingData";
import qs from "qs";

export const getDownloadTypes = async () => {
  var config = {
    method: "get",
    url: `/api/download/types`,
    headers: { "Content-Type": "application/json" },
  };
  let data = await GetData(config);
  return data;
};

export const getDownloadTypeColumns = async (typeId) => {
  var config = {
    method: "get",
    url: `/api/download/types/${typeId}/columns`,
    headers: { "Content-Type": "application/json" },
  };
  let data = await GetData(config);
  return data;
};

export const getOrgCanIds = async () => {
  var config = {
    method: "get",
    url: `/api/download/can-ids`,
    headers: { "Content-Type": "application/json" },
  };
  let data = await GetData(config);
  return data;
};

export const submitDownloadRequest = async (payload) => {
  var config = {
    method: "post",
    url: `/api/downloads`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  let data = await GetData(config);
  return data;
};

export const getDownloadHistory = async (filters = {}) => {
  var config = {
    method: "get",
    url: `/api/downloads`,
    headers: { "Content-Type": "application/json" },
    params: filters,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  };
  let data = await GetData(config);
  return data;
};

export const getDownloadDetail = async (uuid) => {
  var config = {
    method: "get",
    url: `/api/downloads/${uuid}`,
    headers: { "Content-Type": "application/json" },
  };
  let data = await GetData(config);
  return data;
};

export const searchVehicles = async (columnName, search, limit = 10) => {
  var config = {
    method: "get",
    url: `/api/batteries/search_suggestions`,
    headers: { "Content-Type": "application/json" },
    params: { columnName, columnSearch: search, columnLimit: limit },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  };
  let data = await GetData(config);
  return data;
};
